import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTES } from '../../../shared/utils/routes';

@Component({
  selector: 'mob-header-landing',
  templateUrl: './header-landing.component.html',
  styleUrls: ['./header-landing.component.scss'],
})
export class HeaderLandingComponent {
  @Input() VO: any;
  @Output() clickEvent: EventEmitter<any> = new EventEmitter();

  constructor(public router: Router) {}
  goHome() {
    this.router.navigate([ROUTES.landing.url]);
  }
}
